export const joursSemaine = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];
export const mois = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
];

export const SECTION_NAME = {
  ventilation: 'ventilation',
  tarifiaction: 'tarifiaction'
}
export const VENTILATION = [
  { id: 0, description: 'Defaut' },
  { id: 1, description: 'Global' },
  { id: 2, description: 'Individuel' },
  { id: 3, description: 'Journalier' },
]
export const TARIFICATION = [
  { id: -1, description: 'Utiliser/Entête' },
  { id: 0, description: 'Global' },
  { id: 1, description: 'Durée' },
  { id: 2, description: 'Personnes' },
  { id: 3, description: 'Durée/Personnes' },
]
export const STATUT_RESIDENT = [
  { id: 0, description: 'Tous' },
  { id: 1, description: 'Résident' },
  { id: 2, description: 'Non-Résident' },
]
export const STATUT_MEMBRE = [
  { id: 0, description: 'Tous' },
  { id: 1, description: 'Membre' },
  { id: 2, description: 'Non-Membre' },
]